export function openOauthLoginPopup(args = {}, customToken, providerId) {
  console.log('openOauthLoginPopup called with args: ', args)
  let targetUrl =
    window.location.origin +
    `/oauth2Login${args.state?.showWarning ? 'Warning' : ''}?args=` +
    encodeURIComponent(JSON.stringify(args)) +
    (providerId ? '&providerId=' + encodeURIComponent(providerId) : '')

  if (customToken) {
    targetUrl += `&custom_token=${encodeURIComponent(customToken)}`
  }
  console.log('Target url = ', targetUrl)
  return popupCenter(targetUrl, 'Authorization', 520, 622)
}
function popupCenter(url, title, w, h) {
  const left = screen.width / 2 - w / 2
  const top = screen.height / 2 - h / 2
  const newWindow = window.open(
    url,
    title,
    'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=' +
      w +
      ', height=' +
      h +
      ', top=' +
      top +
      ', left=' +
      left,
  )

  if (newWindow?.focus) newWindow.focus()
  return newWindow
}
